import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  FormControlLabel,
  Switch
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const WeeklyRestRules = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Weekly Rest Rules</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Max Consecutive Duty Days"
              type="number"
              value={baseline.maxConsecutiveDutyDays}
              onChange={(e) => handleChange('maxConsecutiveDutyDays', parseInt(e.target.value))}
              inputProps={{ min: 1, max: 10 }}
              helperText="Before weekly rest (CAR Section 7, Series J)"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Weekly Rest Hours"
              type="number"
              value={baseline.weeklyRestHours}
              onChange={(e) => handleChange('weeklyRestHours', parseFloat(e.target.value))}
              inputProps={{ min: 24, max: 72, step: 0.5 }}
              helperText="Minimum weekly rest (CAR Section 7, Series J)"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={baseline.requireTwoLocalNights}
                  onChange={(e) => handleChange('requireTwoLocalNights', e.target.checked)}
                />
              }
              label="Require Two Local Nights (CAR Section 7, Series J)"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default WeeklyRestRules;
